import { FailedIcon, FailedIcon2, SuccessIcon, SuccessIcon2 } from '@assets/icons';
import { ArrowBackIcon } from '@chakra-ui/icons';
import { Box, Button, Flex, Text, VStack } from '@chakra-ui/react';
import { useState } from 'react';

export default function PostUploadModal({
    isSuccess = true,
    onClose = () => {},
    data = {},
    isCustomer = false,
    errorMessage,
}) {
    const [isSeeDetail, setIsSeeDetail] = useState(false);
    const Icon = isSuccess ? SuccessIcon2 : FailedIcon2;
    const { count_failed, count_success, count_update, failed_sku_list } = data;

    const renderDetail = ({ isSuccess, message }) => {
        const Icon = isSuccess ? SuccessIcon : FailedIcon;

        return (
            <Flex
                w={'full'}
                p={'12px 16px'}
                alignItems="center"
                bg={isSuccess ? 'success.100' : 'danger.100'}
                borderRadius="4px"
                borderLeft={`4px solid ${isSuccess ? '#33995E' : '#E6001C'}`}
                gap={'12px'}
            >
                <Box>
                    <Icon size={20} />
                </Box>
                <Text fontSize={'xs'}>{message}</Text>

                {!isSuccess && !errorMessage && (
                    <Button
                        ml={'auto'}
                        fontWeight={'400'}
                        fontSize={'xs'}
                        variant={'link'}
                        colorScheme="danger"
                        px={'0 !important'}
                        _hover={{
                            textDecor: 'underline',
                        }}
                        onClick={() => setIsSeeDetail((prev) => !prev)}
                    >
                        Lihat Detail
                    </Button>
                )}
            </Flex>
        );
    };

    return (
        <Box textAlign="center">
            {isSeeDetail ? (
                <Box>
                    <Flex alignItems={'center'}>
                        <Button onClick={() => setIsSeeDetail((prev) => !prev)} variant={'unstyled'}>
                            <ArrowBackIcon fontSize={'sm'} />
                        </Button>
                        <Text fontWeight={'normal'} fontSize={'sm'}>
                            {isCustomer ? 'Customer' : 'SKU'} Gagal Ditambahkan
                        </Text>
                    </Flex>

                    <Box my={'32px'} ml={'36px'} textAlign={'left'} maxH={'300px'} overflowY={'scroll'}>
                        {failed_sku_list.map((data, idx) => (
                            <Text key={idx}>
                                {idx + 1}. {data}
                            </Text>
                        ))}
                    </Box>
                </Box>
            ) : (
                <Box>
                    <VStack>
                        <Box h={'145px'}>
                            <Icon />
                        </Box>

                        <Text fontSize={'sm'} fontWeight="600">
                            File {isSuccess ? 'berhasil' : 'gagal'} diupload!
                        </Text>
                        <Text fontSize={'xs'} fontWeight="400" lineHeight={0.7}>
                            {isSuccess
                                ? 'Lanjutkan pembuatan promotion claim.'
                                : 'Mohon periksa kembali file Anda, kemudian upload ulang.'}
                        </Text>
                    </VStack>

                    <Flex my={'32px'} gap={'16px'} flexDir={'column'}>
                        {count_success > 0 &&
                            renderDetail({
                                isSuccess: true,
                                message: `${count_success} ${isCustomer ? 'Customer' : 'SKU'} berhasil ditambahkan`,
                            })}
                        {count_update > 0 &&
                            renderDetail({
                                isSuccess: true,
                                message: `${count_update} ${isCustomer ? 'Customer' : 'SKU'} berhasil diperbaharui`,
                            })}
                        {count_failed > 0 &&
                            renderDetail({
                                isSuccess: false,
                                message: `${count_failed} ${
                                    isCustomer ? 'Customer' : 'SKU'
                                } gagal ditambahkan, cek dan upload ulang`,
                            })}
                        {errorMessage &&
                            renderDetail({
                                isSuccess: false,
                                message: errorMessage,
                            })}
                    </Flex>
                </Box>
            )}

            <Flex justify="center" gap="12px">
                <Button px="54px" onClick={onClose}>
                    Tutup
                </Button>
            </Flex>
        </Box>
    );
}
